"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.columnType = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _HeaderCell = _interopRequireDefault(require("../HeaderCell/HeaderCell"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var columnType = {
  Header: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func]),
  accessor: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func]),

  /**
   * Required if accessor is a function
   */
  id: _propTypes.string,

  /**
   * Use Cell function to format cell instead of pass element as value
   * so the cell can be filtered using built-in useFilters or useGlobalFilter
   */
  Cell: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func]),

  /*
   * If width is set (number, px, rem, but not percentage) and the space is not enough,
   * will truncate the cell with ellipsis
   * (percentage value will not truncate the cell)
   */
  width: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  minWidth: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),

  /**
   * Whether to hide the column
   * because the column still needs to be used in sorting and filtering, so need to be included but hidden.
   */
  hidden: _propTypes.bool
};
exports.columnType = columnType;

var TableHeaderRow = function TableHeaderRow(_ref) {
  var role = _ref.role,
      headers = _ref.headers,
      separate = _ref.separate,
      headerCellCls = _ref.headerCellCls,
      disabled = _ref.disabled;
  return (0, _jsxRuntime.jsx)("tr", {
    role: role,
    children: headers.map(function (column) {
      return (0, _jsxRuntime.jsx)("th", _objectSpread(_objectSpread({}, column.getHeaderProps(column.getSortByToggleProps())), {}, {
        scope: "col",
        children: (0, _jsxRuntime.jsx)(_HeaderCell["default"], {
          canSort: column.canSort,
          isSorted: column.isSorted,
          isSortedDesc: column.isSortedDesc,
          separate: separate,
          css: headerCellCls,
          disabled: disabled,
          children: column.render('Header')
        })
      }));
    })
  });
};

TableHeaderRow.propTypes = {
  role: _propTypes.string,
  headers: (0, _propTypes.arrayOf)((0, _propTypes.shape)(columnType)),
  separate: _propTypes.bool,
  headerCellCls: (0, _propTypes.shape)({
    styles: _propTypes.string
  }),
  disabled: _propTypes.bool
};
TableHeaderRow.defaultProps = {
  role: 'row',
  headers: [],
  separate: false,
  headerCellCls: undefined,
  disabled: false
};
var _default = TableHeaderRow;
exports["default"] = _default;
//# sourceMappingURL=TableHeaderRow.js.map